<template>
    <ButtonCircle :disabled="disabled" @click="switchPaintSide" title="Paint">
        <i class="icon-brush"></i>
        <i class="icon-shuffle"></i>
    </ButtonCircle>
</template>

<script>
    import { mapActions } from 'vuex';
    import ButtonCircle from "../../components/ButtonCircle";

    export default {
        name: "PaintSwitchSideOnly",

        components: {ButtonCircle},

        props: [
            'disabled',
        ],

        emits: [
            'close',
        ],

        methods: {
            ...mapActions('paint', [
                'switchPaintSide',
            ]),

            closeModal() {
                this.$emit('close');
            },
        }
    }
</script>

<style scoped>
    button {
        position: relative;
        z-index: 1;
    }

    .icon-brush {
        position: relative;
        top: -2px;
        left: -2px;
    }

    .icon-shuffle {
        position: absolute;
        z-index: 0;
        bottom: 0px;
        right: -2px;
        transform: scale(0.65, 0.65);
    }
</style>